import { AxiosClientFactory } from '../../../common/helpers/AxiosClientFactory';

export const markAsUnread =  (id: number) => {
        return AxiosClientFactory
            .getInstance()
            .post(`/api/inboundSmses/${id}/markAsUnread`, {});
};
